import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ToggleDisplay from './../../../components/shared/ToggleDisplay'
import SelectSearchContainer from './../../../components/shared/SelectSearchContainer'
import { copy } from '../../constants'
import { mapRole } from './util'

import {
  Row,
  Col,
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Radio,
} from 'react-bootstrap'

export const EditUser = (props) => {
  const {
    user,
    onCancel,
    onSave,
    brokerages,
    onBrokerageChange,
    currentBrokerage,
    adminSelectorDisabled,
  } = props
  const [email, setEmail] = useState('')
  const [isAdmin, setIsAdmin] = useState(true)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [title, setTitle] = useState('')
  const [phone, setPhone] = useState('')
  const [phoneExt, setPhoneExt] = useState('')
  const [brokerageChangeActive, setBrokerageChangeActive] = useState(false)
  const [newBrokerage, setNewBrokerage] = useState(null)

  useEffect(() => {
    if (user) {
      setEmail(user.email)
      setIsAdmin(user.role ? user.role.includes('admin') : false)
      setFirstName(user.firstName)
      setLastName(user.lastName)
      setTitle(user.title)
      setPhone(user.phone)
      setPhoneExt(user.phoneExt)
    }
  }, [user])

  const handleCancel = () => {
    setBrokerageChangeActive(false)
    onCancel?.()
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (
      !firstName ||
      firstName.length === 0 ||
      !lastName ||
      lastName.length === 0 ||
      !phone ||
      phone.length === 0
    ) {
      return
    }

    onSave?.({
      ...user,
      email: email,
      role: mapRole(user.role, isAdmin),
      firstName: firstName,
      lastName: lastName,
      title: title,
      phone: phone,
      phoneExt: phoneExt,
    })

    if (Array.isArray(brokerages) && newBrokerage !== null) {
      const brokerage = brokerages.filter((b) => b.brokerId === newBrokerage)[0]
      onBrokerageChange(
        {
          ...user,
        },
        brokerage,
      )
    }
  }

  const renderHelpBlock = (text, helpClass) => (
    <HelpBlock className={`${helpClass}`}>{text}</HelpBlock>
  )

  const orderBrokerages = (brokerages) => {
    return brokerages.filter((b) => b.brokerId !== currentBrokerage.brokerId)
  }

  return (
    <div className="editUserModal">
      <p>Email:</p>
      <h4>{email}</h4>
      <p className="editAdminText">Is user an admin?</p>
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <br />
          <Radio
            name="isAdmin"
            className="editAdminInput"
            inline
            required
            onChange={() => setIsAdmin(true)}
            value={true}
            checked={isAdmin}
            disabled={adminSelectorDisabled}
          >
            Yes
          </Radio>{' '}
          <Radio
            name="isAdmin"
            className="editAdminInput"
            inline
            required
            onChange={() => setIsAdmin(false)}
            value={false}
            checked={isAdmin === false}
            disabled={adminSelectorDisabled}
          >
            No
          </Radio>
        </FormGroup>

        <Row>
          <Col xs={12} sm={8} md={8} lg={10}>
            <p className="adminEditAddInfo">
              {copy.lang('brokersEditUserGroupTip', {
                brokerageName: copy.clean(currentBrokerage.name) || 'Brokerage',
              })}
            </p>
          </Col>
        </Row>

        <FormGroup controlId="firstName">
          <ControlLabel>First Name</ControlLabel>
          <FormControl
            id="firstName"
            name="firstName"
            type="text"
            label="Text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          {!firstName || firstName.length === 0 ? (
            renderHelpBlock('*Required', 'helpBlockRed')
          ) : (
            <div className="completeSpace" />
          )}
        </FormGroup>
        <FormGroup controlId="lastName">
          <ControlLabel>Last Name</ControlLabel>
          <FormControl
            id="lastName"
            name="lastName"
            type="text"
            label="Text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          {!lastName || lastName.length === 0 ? (
            renderHelpBlock('*Required', 'helpBlockRed')
          ) : (
            <div className="completeSpace" />
          )}
        </FormGroup>
        <FormGroup controlId="title">
          <ControlLabel>Job Title</ControlLabel>
          <FormControl
            id="title"
            name="title"
            type="text"
            label="Text"
            placeholder="optional"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <div className="completeSpace" />
        </FormGroup>
        <Row>
          <Col xs={8} sm={8} md={8} lg={8}>
            <FormGroup controlId="phone">
              <ControlLabel>Phone Number</ControlLabel>
              <FormControl
                id="phone"
                name="phone"
                type="text"
                label="Text"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              {!phone || phone.length === 0 ? (
                renderHelpBlock('*Required', 'helpBlockRed')
              ) : (
                <div className="completeSpace" />
              )}
            </FormGroup>
          </Col>
          <Col xs={4} sm={4} md={4} lg={4}>
            <FormGroup controlId="phoneExt">
              <ControlLabel>Ext</ControlLabel>
              <FormControl
                id="phoneExt"
                name="phoneExt"
                type="text"
                label="Text"
                placeholder="optional"
                value={phoneExt}
                onChange={(e) => setPhoneExt(e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>
        <ToggleDisplay
          show={brokerageChangeActive}
          render={() => (
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <FormGroup controlId="brokerageChange" className="adminEditAddInfo">
                  <ControlLabel>
                    Move the user account to the following brokerage office
                    <br />
                    <span className="greyLabel">
                      Current brokerage is: <strong>{currentBrokerage.name}</strong>
                    </span>
                  </ControlLabel>

                  <Row>
                    <Col xs={12} sm={8} md={8} lg={10}>
                      <div className="box-warning">
                        {copy.lang('brokersEditBrokerageChangeWarning', {
                          brokerageName: copy.clean(currentBrokerage.name) || 'Brokerage',
                        })}
                      </div>
                    </Col>
                  </Row>

                  <SelectSearchContainer
                    options={orderBrokerages(brokerages)}
                    labelColumn={'name'}
                    valueColumn={'brokerId'}
                    value={newBrokerage}
                    onChange={(e) => setNewBrokerage(e.value)}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
        />
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div>
              <Button className="saveEditChanges" type="submit">
                Save Changes
              </Button>
              <ToggleDisplay
                hide={brokerageChangeActive}
                render={() => (
                  <Button
                    className="saveEditChanges"
                    onClick={() => setBrokerageChangeActive(true)}
                  >
                    Change Brokerage Office
                  </Button>
                )}
              />
              <Button className="cancelEdit secondary" onClick={handleCancel}>
                Cancel
              </Button>
            </div>
          </Col>
        </Row>
      </form>
    </div>
  )
}

EditUser.propTypes = {
  user: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  adminSelectorDisabled: PropTypes.bool,
}
